import { useIntl } from 'react-intl';

import { Text } from '@fhs/ui';
import { Box } from '@fhs-legacy/universal-components';
import { useConfigValue } from 'hooks/configs/use-config-value';
import { readableTimeInterval } from 'utils/restaurant';
import { TWELVE_HOUR_TIME_PARSE_FORMAT } from 'utils/restaurant/constants';

import { InnerHeader, StoreHourContainer } from './styled';
import { IHoursProps } from './types';

// Week days following JavaScript Date.getDay() indexes order
const weekDays: [string, string][] = [
  ['sunday', 'sun'],
  ['monday', 'mon'],
  ['tuesday', 'tue'],
  ['wednesday', 'wed'],
  ['thursday', 'thr'],
  ['friday', 'fri'],
  ['saturday', 'sat'],
];

const getSortedWeekDays = (): [string, string][] => {
  const todayIndex = new Date().getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  return [...weekDays.slice(todayIndex), ...weekDays.slice(0, todayIndex)];
};

export const Hours = ({ title, hours }: IHoursProps) => {
  const { formatMessage } = useIntl();
  const timeFormatConfig = useConfigValue({
    key: 'timeFormat',
    defaultValue: TWELVE_HOUR_TIME_PARSE_FORMAT,
  });
  const hoursOfOperation = readableTimeInterval({
    fallbackMessage: formatMessage({ id: 'hoursOfOperationFallbackMessage' }),
    open24HoursMessage: formatMessage({ id: 'open24Hours' }),
    timeFormat: timeFormatConfig,
  });

  if (!hours) {
    return null;
  }

  const sortedWeekDays = getSortedWeekDays();

  return (
    <Box>
      <InnerHeader variant="headerThree" marginY="$2">
        {title}
      </InnerHeader>
      {sortedWeekDays.map(([messageId, abbreviatedDay], index) => {
        const openingHours = hours[`${abbreviatedDay}Open`];
        const closingHours = hours[`${abbreviatedDay}Close`];
        const fontWeight = index === 0 ? 'semibold' : 'normal';

        return (
          <StoreHourContainer key={messageId}>
            <Text weight={fontWeight}>{formatMessage({ id: messageId })}</Text>
            <Text weight={fontWeight}>{hoursOfOperation(openingHours, closingHours)}</Text>
          </StoreHourContainer>
        );
      })}
    </Box>
  );
};
